// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { isFullAccess } from '../../../../../../common/permissions/permissionUtil';

// Selectors
import {
    currentBoardHasPublicEditPermissionsSelector,
    currentBoardIsPublishedSelector,
    currentBoardSpecificUserPermissionsSelector,
    currentBoardUserPermissionsSelector,
} from '../../../../../utils/permissions/elementPermissionsSelector';

// Components
import ShareModalContent from './ShareModalContent';
import FullScreenModal from '../../../../../components/modal/FullScreenModal';

// Constants
import { ModalIds } from '../../../../../components/modal/modalConstants';

// Styles
import './ShareModal.scss';

const mapStateToProps = createStructuredSelector({
    userPermission: currentBoardUserPermissionsSelector,
    specificUserPermissions: currentBoardSpecificUserPermissionsSelector,
    currentBoardIsPublished: currentBoardIsPublishedSelector,
    currentBoardHasPublicEditPermissions: currentBoardHasPublicEditPermissionsSelector,
});

const ShareModal = (props) => {
    const { userPermission } = props;

    // Safety catch in case a user without edit permissions tries to access this modal
    if (!isFullAccess(userPermission)) return null;

    return (
        <FullScreenModal modalName={ModalIds.SHARE} className="ShareModal" {...props} overlay styled={false}>
            <ShareModalContent {...props} />
        </FullScreenModal>
    );
};

ShareModal.propTypes = {
    currentBoardId: PropTypes.string,
    mode: PropTypes.string,
    userPermission: PropTypes.number,
    specificUserPermissions: PropTypes.number,

    currentBoardIsPublished: PropTypes.bool,
    currentBoardHasPublicEditPermissions: PropTypes.bool,

    dispatchSetMode: PropTypes.func,
};

export default connect(mapStateToProps)(ShareModal);
